import { Suspense } from "react";
import ErrorBoundary from "../ErrorBoundary/ErrorBoundary";

// Bug real (auditoría 2026-08-16): el fallback era un <span
// className="visually-hidden"> (utilidad de Bootstrap para lectores de
// pantalla) — mientras el chunk lazy-cargado se descarga, un usuario vidente
// veía la pantalla completamente en blanco, sin ningún spinner, a diferencia
// de los otros estados de carga de App.js (que sí usan spinner-border). Este
// componente envuelve rutas/pantallas enteras (Onboarding, Monitor, el resto
// de la app autenticada), así que en una conexión lenta o cache fría
// post-deploy esto se lee como una app trabada, no "cargando".
const Component = ({ children }) => {
  return (
    <ErrorBoundary>
      <Suspense fallback={
        <div className="vh-100 p-5 d-flex justify-content-center align-items-center">
          <div className="spinner-border" role="status"></div>
        </div>
      }>
        {children}
      </Suspense>
    </ErrorBoundary>
  );
};

export default Component;
